import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/device-camera'

const ensureSuccess = (response) => {
  if (response.data?.status === false || response.data?.status >= 400) {
    throw new Error(response.data?.message || response.data?.data?.message)
  }

  return response?.data
}

export const get = async (queryParam, serverRegion) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
    sorts: queryParam?.sorts || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response?.data
}

export const create = async (payload, serverRegion) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data: payload,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return ensureSuccess(response)
}

export const update = async (deviceCode, payload, serverRegion) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${deviceCode}`,
    data: payload,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return ensureSuccess(response)
}
export const remove = async (deviceCode, serverRegion) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/${deviceCode}`,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return ensureSuccess(response)
}
